import { useMutation } from "react-query";
import { postWithBearer } from "utils/authApi";
import { API_MFA_SETUP_SMS } from "consts";

export default function useMfaSetupSms(config) {
  return useMutation(
    ({ accessToken, phoneNumber }) =>
      postWithBearer(API_MFA_SETUP_SMS, { phoneNumber }, accessToken),
    config
  );
}
